/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: bvRZj1oZhhFBeMnkX2LkQu
// Component: XTAvGJPchvtf

import * as React from "react";

import Head from "next/head";
import Link, { LinkProps } from "next/link";
import { useRouter } from "next/router";

import {
  Flex as Flex__,
  MultiChoiceArg,
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  PlasmicIcon as PlasmicIcon__,
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  PlasmicPageGuard as PlasmicPageGuard__,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  Stack as Stack__,
  StrictProps,
  Trans as Trans__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  ensureGlobalVariants,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  get as $stateGet,
  hasVariant,
  initializeCodeComponentStates,
  initializePlasmicStates,
  makeFragment,
  omit,
  pick,
  renderPlasmicSlot,
  set as $stateSet,
  useCurrentUser,
  useDollarState,
  usePlasmicTranslator,
  useTrigger,
  wrapWithClassName
} from "@plasmicapp/react-web";
import {
  DataCtxReader as DataCtxReader__,
  useDataEnv,
  useGlobalActions
} from "@plasmicapp/react-web/lib/host";

import { DataProvider } from "@plasmicpkgs/plasmic-basic-components";
import SectionHeader from "../../SectionHeader"; // plasmic-import: BZA1gY3bmqLJ/component
import Accordion from "../../Accordion"; // plasmic-import: arnwjGJ19TeR/component
import AccordionSection from "../../AccordionSection"; // plasmic-import: ts0SJTqXQoqH/component
import AccordionSectionHeader from "../../AccordionSectionHeader"; // plasmic-import: kAWnPiDkalqP/component
import AccordionSectionSplashImage from "../../AccordionSectionSplashImage"; // plasmic-import: 9c2uJ0XQl9b8/component
import HomeProductsSectionQuote from "../../HomeProductsSectionQuote"; // plasmic-import: 3LBYSAoY9tVV/component
import { _useGlobalVariants } from "./plasmic"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectModule
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic.module.css"; // plasmic-import: bvRZj1oZhhFBeMnkX2LkQu/projectcss
import sty from "./PlasmicHomeProductsSection.module.css"; // plasmic-import: XTAvGJPchvtf/css

import G78Icon from "./icons/PlasmicIcon__G78"; // plasmic-import: 6-z87csDA4ng/icon
import Path84Icon from "./icons/PlasmicIcon__Path84"; // plasmic-import: Jg7OZ5O9QTsJ/icon
import G94Icon from "./icons/PlasmicIcon__G94"; // plasmic-import: Xb_CKC_uwFbQ/icon
import G90Icon from "./icons/PlasmicIcon__G90"; // plasmic-import: vHRkoL0I_0zZ/icon
import SubtractIcon from "./icons/PlasmicIcon__Subtract"; // plasmic-import: dOunpx9IO7m8/icon
import Subtract3Icon from "./icons/PlasmicIcon__Subtract3"; // plasmic-import: yV-m-xkrICVZ/icon

createPlasmicElementProxy;

export type PlasmicHomeProductsSection__VariantMembers = {};
export type PlasmicHomeProductsSection__VariantsArgs = {};
type VariantPropType = keyof PlasmicHomeProductsSection__VariantsArgs;
export const PlasmicHomeProductsSection__VariantProps =
  new Array<VariantPropType>();

export type PlasmicHomeProductsSection__ArgsType = {};
type ArgPropType = keyof PlasmicHomeProductsSection__ArgsType;
export const PlasmicHomeProductsSection__ArgProps = new Array<ArgPropType>();

export type PlasmicHomeProductsSection__OverridesType = {
  productsSection?: Flex__<"section">;
  productsProvider?: Flex__<typeof DataProvider>;
  desktopWrapper?: Flex__<"div">;
  row?: Flex__<"div">;
  row2?: Flex__<"div">;
  leftColumn?: Flex__<"div">;
  bodyWrapper?: Flex__<"div">;
  imgWrapper?: Flex__<"div">;
  text?: Flex__<"div">;
  title?: Flex__<"h4">;
  subtitle?: Flex__<"p">;
  features?: Flex__<"div">;
  list?: Flex__<"div">;
  rightColumn?: Flex__<"div">;
  nav?: Flex__<"div">;
  sliderNavigation?: Flex__<"div">;
  sliderNavigationBullet?: Flex__<"div">;
  sliderNavigationBullet2?: Flex__<"div">;
  sliderNavigationBullet3?: Flex__<"div">;
  sliderNavigationBullet4?: Flex__<"div">;
  sliderNavigationBullet5?: Flex__<"div">;
  sliderNavigationBullet6?: Flex__<"div">;
  sliderNavigationBullet7?: Flex__<"div">;
  sliderNavigationBullet8?: Flex__<"div">;
  sliderNavigationBullet9?: Flex__<"div">;
  mobileWrapper?: Flex__<"div">;
  row3?: Flex__<"div">;
  freeBox?: Flex__<"div">;
  nav2?: Flex__<"div">;
  img5?: Flex__<"div">;
  logoIcon2?: Flex__<"div">;
  logo4?: Flex__<"div">;
  logo5?: Flex__<"div">;
  logo6?: Flex__<"div">;
  row4?: Flex__<"div">;
  leftColumn2?: Flex__<"div">;
  bodyWrapper2?: Flex__<"div">;
  text2?: Flex__<"div">;
  title2?: Flex__<"h4">;
  subtitle2?: Flex__<"p">;
  features2?: Flex__<"div">;
  list2?: Flex__<"div">;
  quote?: Flex__<"div">;
  sliderNavigation2?: Flex__<"div">;
  sliderNavigationBullet10?: Flex__<"div">;
  sliderNavigationBullet11?: Flex__<"div">;
  sliderNavigationBullet12?: Flex__<"div">;
  sliderNavigationBullet13?: Flex__<"div">;
  sliderNavigationBullet14?: Flex__<"div">;
  sliderNavigationBullet15?: Flex__<"div">;
  sliderNavigationBullet16?: Flex__<"div">;
  sliderNavigationBullet17?: Flex__<"div">;
  sliderNavigationBullet18?: Flex__<"div">;
};

export interface DefaultHomeProductsSectionProps {
  className?: string;
}

const $$ = {};

function useNextRouter() {
  try {
    return useRouter();
  } catch {}
  return undefined;
}

function PlasmicHomeProductsSection__RenderFunc(props: {
  variants: PlasmicHomeProductsSection__VariantsArgs;
  args: PlasmicHomeProductsSection__ArgsType;
  overrides: PlasmicHomeProductsSection__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const __nextRouter = useNextRouter();

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const globalVariants = _useGlobalVariants();

  const stateSpecs: Parameters<typeof useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "accordion",
        type: "private",
        variableType: "number",
        initFunc: ({ $props, $state, $queries, $ctx }) => 0
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  const styleTokensClassNames = _useStyleTokens();

  return (
    <section
      data-plasmic-name={"productsSection"}
      data-plasmic-override={overrides.productsSection}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.productsSection
      )}
    >
      <DataProvider
        data-plasmic-name={"productsProvider"}
        data-plasmic-override={overrides.productsProvider}
        className={classNames("__wab_instance", sty.productsProvider)}
        data={[
          {
            product: "myEvaluations",
            header:
              "System integrating evaluations, milestones, EPAs, quizzes, schedules and more.",
            title: "Experience the Future of Medical Education Management",
            subtitle:
              "MyEvaluations revolutionizes medical training management with streamlined scheduling, patient logs, clinical hour compliance, and custom evaluations. Its efficient workflow and secure, accessible platform save time, resources, and paper, while enabling comprehensive reports and early intervention alerts for improved training outcomes.",
            bulletPoints: {
              bulletpointsLeft: [
                "Evaluations, Milestones & EPAs",
                "Performance Improvement Plans & Clinical Learning Contracts",
                "Scheduling and Compliance",
                "Educational Compliance",
                "ACGME Compliance Tracking"
              ],
              bulletpointsRight: [
                "Curriculum Management",
                "MyQuiz & Learning Assignments",
                "Procedure & Patient Logging",
                "Return Demonstrations",
                "Administrative Tools"
              ]
            }
          },
          {
            product: "myCme",
            header:
              "CME management from credit tracking to critical report generation.",
            title: "Unified Solution To Manage, Track, and Report CME Credits",
            subtitle:
              "MyCME facilitates the fulfilment of CME requirements. Organizations can automate PARS reports and maintain cross-departmental financial records. In turn, faculty members gain a unified system for tracking evaluations and reporting MOC to various boards supported by the ACCME.",
            bulletPoints: {
              bulletpointsLeft: [
                "Live & Durable Event Scheduling",
                "CME Certificate Management"
              ],
              bulletpointsRight: [
                "ACCME Connectivity to PARS",
                "Event Financial Management"
              ]
            }
          },
          {
            product: "myGme",
            header:
              "Fiscal management including submitting work-hour data to Medicare",
            title: "Step Into a World of Simplified GME Financial Management",
            subtitle:
              "My GME Fiscal utilizes data from MyEvaluations for precise fiscal management, particularly in Medicare reimbursements. With features like Master Rotation Schedules, Gap and Overlap Analysis, and detailed reports, it provides comprehensive oversight. Use it to ensure accurate submissions and gain unhindered access to critical information.",
            bulletPoints: {
              bulletpointsLeft: [
                "Reimbursement & Cost Reporting",
                "IRIS/STAR Export",
                "Billing & Invoicing",
                "FTE Reports & CAP Analysis"
              ],
              bulletpointsRight: [
                "Audit Management",
                "Errors & Omissions Analysis",
                "MyQuickPass Integration"
              ]
            }
          }
        ]}
        name={"products"}
      >
        <DataCtxReader__>
          {$ctx => (
            <React.Fragment>
              {(
                hasVariant(globalVariants, "mobile", "mobile")
                  ? false
                  : hasVariant(globalVariants, "mobile", "tabletPortrait")
                    ? false
                    : true
              ) ? (
                <div
                  data-plasmic-name={"desktopWrapper"}
                  data-plasmic-override={overrides.desktopWrapper}
                  className={classNames(projectcss.all, sty.desktopWrapper)}
                >
                  <div
                    data-plasmic-name={"row"}
                    data-plasmic-override={overrides.row}
                    className={classNames(projectcss.all, sty.row)}
                  >
                    <SectionHeader
                      className={classNames(
                        "__wab_instance",
                        sty.sectionHeader__zwejz
                      )}
                      description={
                        "Discover our suite of products combining MyEvaluations as the core, expanded with MyCME and MyGME Fiscal for enhanced education, fiscal management, and continuing medical education support."
                      }
                      showDescription={true}
                      showSubtitle={true}
                      subtitle={"our products"}
                      title={
                        "Comprehensive Medical Educational Management Suite"
                      }
                    />
                  </div>
                  <div
                    data-plasmic-name={"row2"}
                    data-plasmic-override={overrides.row2}
                    className={classNames(projectcss.all, sty.row2)}
                  >
                    <div
                      data-plasmic-name={"leftColumn"}
                      data-plasmic-override={overrides.leftColumn}
                      className={classNames(projectcss.all, sty.leftColumn)}
                    >
                      <Accordion
                        className={classNames(
                          "__wab_instance",
                          sty.accordion__gj1LP
                        )}
                      >
                        {(_par =>
                          !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                          (() => {
                            try {
                              return $ctx.products;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()
                        ).map((__plasmic_item_0, __plasmic_idx_0) => {
                          const currentItem = __plasmic_item_0;
                          const currentIndex = __plasmic_idx_0;
                          return (
                            <AccordionSection
                              active={(() => {
                                try {
                                  return currentIndex === $state.accordion;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return [];
                                  }
                                  throw e;
                                }
                              })()}
                              body={
                                <div
                                  data-plasmic-name={"bodyWrapper"}
                                  data-plasmic-override={overrides.bodyWrapper}
                                  className={classNames(
                                    projectcss.all,
                                    sty.bodyWrapper
                                  )}
                                >
                                  <div
                                    data-plasmic-name={"imgWrapper"}
                                    data-plasmic-override={overrides.imgWrapper}
                                    className={classNames(
                                      projectcss.all,
                                      sty.imgWrapper
                                    )}
                                  >
                                    <AccordionSectionSplashImage
                                      className={classNames(
                                        "__wab_instance",
                                        sty.accordionSectionSplashImage__xwrxt
                                      )}
                                      product={(() => {
                                        try {
                                          return currentItem.product;
                                        } catch (e) {
                                          if (
                                            e instanceof TypeError ||
                                            e?.plasmicType ===
                                              "PlasmicUndefinedDataError"
                                          ) {
                                            return "myEvaluations";
                                          }
                                          throw e;
                                        }
                                      })()}
                                    />
                                  </div>
                                  <div
                                    data-plasmic-name={"text"}
                                    data-plasmic-override={overrides.text}
                                    className={classNames(
                                      projectcss.all,
                                      sty.text
                                    )}
                                  >
                                    <h4
                                      data-plasmic-name={"title"}
                                      data-plasmic-override={overrides.title}
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.h4,
                                        projectcss.__wab_text,
                                        sty.title
                                      )}
                                    >
                                      <React.Fragment>
                                        {(() => {
                                          try {
                                            return currentItem.title;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return "Experience the Future of Medical Education Management";
                                            }
                                            throw e;
                                          }
                                        })()}
                                      </React.Fragment>
                                    </h4>
                                    <p
                                      data-plasmic-name={"subtitle"}
                                      data-plasmic-override={overrides.subtitle}
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.p,
                                        projectcss.__wab_text,
                                        sty.subtitle
                                      )}
                                    >
                                      <React.Fragment>
                                        {(() => {
                                          try {
                                            return currentItem.subtitle;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return "MyEvaluations revolutionizes medical training management with streamlined scheduling, patient logs, clinical hour compliance, and custom evaluations. Its efficient workflow and secure, accessible platform save time, resources, and paper, while enabling comprehensive reports and early intervention alerts for improved training outcomes.";
                                            }
                                            throw e;
                                          }
                                        })()}
                                      </React.Fragment>
                                    </p>
                                  </div>
                                  <div
                                    data-plasmic-name={"features"}
                                    data-plasmic-override={overrides.features}
                                    className={classNames(
                                      projectcss.all,
                                      sty.features
                                    )}
                                  >
                                    <h6
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.h6,
                                        projectcss.__wab_text,
                                        sty.h6__fxBmc
                                      )}
                                    >
                                      {"Key Features"}
                                    </h6>
                                    <div
                                      data-plasmic-name={"list"}
                                      data-plasmic-override={overrides.list}
                                      className={classNames(
                                        projectcss.all,
                                        sty.list
                                      )}
                                    >
                                      <div
                                        className={classNames(
                                          projectcss.all,
                                          projectcss.__wab_text,
                                          sty.text___99P2Z
                                        )}
                                      >
                                        <React.Fragment>
                                          <React.Fragment>{""}</React.Fragment>
                                          {
                                            <ul
                                              className={classNames(
                                                projectcss.all,
                                                projectcss.ul,
                                                sty.ul__aLQww
                                              )}
                                            >
                                              {(_par =>
                                                !_par
                                                  ? []
                                                  : Array.isArray(_par)
                                                    ? _par
                                                    : [_par])(
                                                (() => {
                                                  try {
                                                    return currentItem
                                                      .bulletPoints
                                                      .bulletpointsLeft;
                                                  } catch (e) {
                                                    if (
                                                      e instanceof TypeError ||
                                                      e?.plasmicType ===
                                                        "PlasmicUndefinedDataError"
                                                    ) {
                                                      return [];
                                                    }
                                                    throw e;
                                                  }
                                                })()
                                              ).map(
                                                (
                                                  __plasmic_item_1,
                                                  __plasmic_idx_1
                                                ) => {
                                                  const currentItem =
                                                    __plasmic_item_1;
                                                  const currentIndex =
                                                    __plasmic_idx_1;
                                                  return (
                                                    <li
                                                      className={classNames(
                                                        projectcss.all,
                                                        projectcss.li,
                                                        projectcss.__wab_text,
                                                        sty.li__aUFuI
                                                      )}
                                                      key={currentIndex}
                                                    >
                                                      <React.Fragment>
                                                        {currentItem}
                                                      </React.Fragment>
                                                    </li>
                                                  );
                                                }
                                              )}
                                            </ul>
                                          }
                                          <React.Fragment>{""}</React.Fragment>
                                        </React.Fragment>
                                      </div>
                                      <div
                                        className={classNames(
                                          projectcss.all,
                                          projectcss.__wab_text,
                                          sty.text__fadav
                                        )}
                                      >
                                        <React.Fragment>
                                          <React.Fragment>{""}</React.Fragment>
                                          {
                                            <ul
                                              className={classNames(
                                                projectcss.all,
                                                projectcss.ul,
                                                sty.ul__xm0Da
                                              )}
                                            >
                                              {(_par =>
                                                !_par
                                                  ? []
                                                  : Array.isArray(_par)
                                                    ? _par
                                                    : [_par])(
                                                (() => {
                                                  try {
                                                    return currentItem
                                                      .bulletPoints
                                                      .bulletpointsRight;
                                                  } catch (e) {
                                                    if (
                                                      e instanceof TypeError ||
                                                      e?.plasmicType ===
                                                        "PlasmicUndefinedDataError"
                                                    ) {
                                                      return [];
                                                    }
                                                    throw e;
                                                  }
                                                })()
                                              ).map(
                                                (
                                                  __plasmic_item_1,
                                                  __plasmic_idx_1
                                                ) => {
                                                  const currentItem =
                                                    __plasmic_item_1;
                                                  const currentIndex =
                                                    __plasmic_idx_1;
                                                  return (
                                                    <li
                                                      className={classNames(
                                                        projectcss.all,
                                                        projectcss.li,
                                                        projectcss.__wab_text,
                                                        sty.li__pXwSp
                                                      )}
                                                      key={currentIndex}
                                                    >
                                                      <React.Fragment>
                                                        {currentItem}
                                                      </React.Fragment>
                                                    </li>
                                                  );
                                                }
                                              )}
                                            </ul>
                                          }
                                          <React.Fragment>{""}</React.Fragment>
                                        </React.Fragment>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                              className={classNames(
                                "__wab_instance",
                                sty.accordionSection__y0WlQ
                              )}
                              header={
                                <AccordionSectionHeader
                                  active={(() => {
                                    try {
                                      return currentIndex === $state.accordion;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })()}
                                  className={classNames(
                                    "__wab_instance",
                                    sty.accordionSectionHeader__n7NDu
                                  )}
                                  onClick={async () => {
                                    const $steps = {};

                                    $steps["updateAccordion"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            variable: {
                                              objRoot: $state,
                                              variablePath: ["accordion"]
                                            },
                                            operation: 0,
                                            value: currentIndex
                                          };
                                          return (({
                                            variable,
                                            value,
                                            startIndex,
                                            deleteCount
                                          }) => {
                                            if (!variable) {
                                              return;
                                            }
                                            const { objRoot, variablePath } =
                                              variable;

                                            $stateSet(
                                              objRoot,
                                              variablePath,
                                              value
                                            );
                                            return value;
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["updateAccordion"] != null &&
                                      typeof $steps["updateAccordion"] ===
                                        "object" &&
                                      typeof $steps["updateAccordion"].then ===
                                        "function"
                                    ) {
                                      $steps["updateAccordion"] =
                                        await $steps["updateAccordion"];
                                    }
                                  }}
                                  order={(() => {
                                    try {
                                      return currentIndex === 0
                                        ? "first"
                                        : currentIndex ===
                                            $ctx.products.length - 1
                                          ? "last"
                                          : "";
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })()}
                                  product={(() => {
                                    try {
                                      return currentItem.product;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                  title={(() => {
                                    try {
                                      return currentItem.header;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                />
                              }
                              key={currentIndex}
                            />
                          );
                        })}
                      </Accordion>
                    </div>
                    <div
                      data-plasmic-name={"rightColumn"}
                      data-plasmic-override={overrides.rightColumn}
                      className={classNames(projectcss.all, sty.rightColumn)}
                    >
                      <div
                        data-plasmic-name={"nav"}
                        data-plasmic-override={overrides.nav}
                        className={classNames(projectcss.all, sty.nav)}
                      >
                        <PlasmicImg__
                          alt={"MyProducts"}
                          className={classNames(sty.img__npJq5)}
                          displayHeight={"100%"}
                          displayMaxHeight={"none"}
                          displayMaxWidth={"none"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={"100%"}
                          loader={"plasmic"}
                          loading={"lazy"}
                          src={{
                            src: "https://site-assets.plasmic.app/f99c69a289bcc2692f7d4bf9233fab05.svg",
                            fullWidth: 365,
                            fullHeight: 372,
                            aspectRatio: 0.981183
                          }}
                        />
                      </div>
                      <HomeProductsSectionQuote
                        className={classNames(
                          "__wab_instance",
                          sty.homeProductsSectionQuote__p06R
                        )}
                      />

                      {false ? (
                        <div
                          data-plasmic-name={"sliderNavigation"}
                          data-plasmic-override={overrides.sliderNavigation}
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigation
                          )}
                        >
                          <div
                            data-plasmic-name={"sliderNavigationBullet"}
                            data-plasmic-override={
                              overrides.sliderNavigationBullet
                            }
                            className={classNames(
                              projectcss.all,
                              sty.sliderNavigationBullet
                            )}
                          />

                          <div
                            data-plasmic-name={"sliderNavigationBullet2"}
                            data-plasmic-override={
                              overrides.sliderNavigationBullet2
                            }
                            className={classNames(
                              projectcss.all,
                              sty.sliderNavigationBullet2
                            )}
                          />

                          <div
                            data-plasmic-name={"sliderNavigationBullet3"}
                            data-plasmic-override={
                              overrides.sliderNavigationBullet3
                            }
                            className={classNames(
                              projectcss.all,
                              sty.sliderNavigationBullet3
                            )}
                          />

                          <div
                            data-plasmic-name={"sliderNavigationBullet4"}
                            data-plasmic-override={
                              overrides.sliderNavigationBullet4
                            }
                            className={classNames(
                              projectcss.all,
                              sty.sliderNavigationBullet4
                            )}
                          />

                          <div
                            data-plasmic-name={"sliderNavigationBullet5"}
                            data-plasmic-override={
                              overrides.sliderNavigationBullet5
                            }
                            className={classNames(
                              projectcss.all,
                              sty.sliderNavigationBullet5
                            )}
                          />

                          <div
                            data-plasmic-name={"sliderNavigationBullet6"}
                            data-plasmic-override={
                              overrides.sliderNavigationBullet6
                            }
                            className={classNames(
                              projectcss.all,
                              sty.sliderNavigationBullet6
                            )}
                          />

                          <div
                            data-plasmic-name={"sliderNavigationBullet7"}
                            data-plasmic-override={
                              overrides.sliderNavigationBullet7
                            }
                            className={classNames(
                              projectcss.all,
                              sty.sliderNavigationBullet7
                            )}
                          />

                          <div
                            data-plasmic-name={"sliderNavigationBullet8"}
                            data-plasmic-override={
                              overrides.sliderNavigationBullet8
                            }
                            className={classNames(
                              projectcss.all,
                              sty.sliderNavigationBullet8
                            )}
                          />

                          <div
                            data-plasmic-name={"sliderNavigationBullet9"}
                            data-plasmic-override={
                              overrides.sliderNavigationBullet9
                            }
                            className={classNames(
                              projectcss.all,
                              sty.sliderNavigationBullet9
                            )}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
              {(
                hasVariant(globalVariants, "mobile", "mobile")
                  ? true
                  : hasVariant(globalVariants, "mobile", "tabletPortrait")
                    ? true
                    : false
              ) ? (
                <div
                  data-plasmic-name={"mobileWrapper"}
                  data-plasmic-override={overrides.mobileWrapper}
                  className={classNames(projectcss.all, sty.mobileWrapper)}
                >
                  <div
                    data-plasmic-name={"row3"}
                    data-plasmic-override={overrides.row3}
                    className={classNames(projectcss.all, sty.row3)}
                  >
                    <SectionHeader
                      className={classNames(
                        "__wab_instance",
                        sty.sectionHeader__ttzZo
                      )}
                      description={
                        "Discover our suite of products combining MyEvaluations as the core, expanded with MyCME and MyGME Fiscal for enhanced education, fiscal management, and continuing medical education support."
                      }
                      showDescription={true}
                      showSubtitle={true}
                      subtitle={"our products"}
                      title={
                        "Comprehensive Medical Educational Management Suite"
                      }
                    />
                  </div>
                  <div
                    data-plasmic-name={"freeBox"}
                    data-plasmic-override={overrides.freeBox}
                    className={classNames(projectcss.all, sty.freeBox)}
                  >
                    <div
                      data-plasmic-name={"nav2"}
                      data-plasmic-override={overrides.nav2}
                      className={classNames(projectcss.all, sty.nav2)}
                    >
                      {(
                        hasVariant(globalVariants, "mobile", "mobile")
                          ? false
                          : hasVariant(
                                globalVariants,
                                "mobile",
                                "tabletPortrait"
                              )
                            ? false
                            : true
                      ) ? (
                        <div
                          data-plasmic-name={"img5"}
                          data-plasmic-override={overrides.img5}
                          className={classNames(projectcss.all, sty.img5)}
                        >
                          <div
                            data-plasmic-name={"logoIcon2"}
                            data-plasmic-override={overrides.logoIcon2}
                            className={classNames(
                              projectcss.all,
                              sty.logoIcon2
                            )}
                          >
                            <G78Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__fWWg
                              )}
                              role={"img"}
                            />

                            <Path84Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__iUy56
                              )}
                              role={"img"}
                            />

                            <G94Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__vcmhv
                              )}
                              role={"img"}
                            />

                            <G90Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__rtLwe
                              )}
                              role={"img"}
                            />

                            <G90Icon
                              className={classNames(
                                projectcss.all,
                                sty.svg__rszGd
                              )}
                              role={"img"}
                            />
                          </div>
                          <SubtractIcon
                            className={classNames(
                              projectcss.all,
                              sty.svg__gp0It
                            )}
                            role={"img"}
                          />

                          <PlasmicImg__
                            alt={""}
                            className={classNames(sty.img__rRq4I)}
                            displayHeight={"268px"}
                            displayMaxHeight={"none"}
                            displayMaxWidth={"171px"}
                            displayMinHeight={"0"}
                            displayMinWidth={"0"}
                            displayWidth={"100%"}
                            loader={"plasmic"}
                            loading={"lazy"}
                            src={{
                              src: "https://site-assets.plasmic.app/3f0f883b8a978737dac60cb91b374fc4.svg",
                              fullWidth: 171,
                              fullHeight: 268,
                              aspectRatio: 0.63806
                            }}
                          />

                          <Subtract3Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg___39XK
                            )}
                            role={"img"}
                          />

                          <div
                            data-plasmic-name={"logo4"}
                            data-plasmic-override={overrides.logo4}
                            className={classNames(projectcss.all, sty.logo4)}
                          >
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__tAbqz)}
                              displayHeight={"29.831px"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"100%"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"170.666px"}
                              loader={"plasmic"}
                              loading={"lazy"}
                              src={{
                                src: "https://site-assets.plasmic.app/88fb0a376dc5250b3187b8477fd28c07.svg",
                                fullWidth: 189.629,
                                fullHeight: 33.146,
                                aspectRatio: 5.588235
                              }}
                            />
                          </div>
                          <div
                            data-plasmic-name={"logo5"}
                            data-plasmic-override={overrides.logo5}
                            className={classNames(projectcss.all, sty.logo5)}
                          >
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__kUaG)}
                              displayHeight={"30.015px"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"100%"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"146.663px"}
                              loader={"plasmic"}
                              loading={"lazy"}
                              src={{
                                src: "https://site-assets.plasmic.app/9bb640df88277ece7fb137400c53b682.svg",
                                fullWidth: 146.663,
                                fullHeight: 30.015,
                                aspectRatio: 4.741935
                              }}
                            />
                          </div>
                          <div
                            data-plasmic-name={"logo6"}
                            data-plasmic-override={overrides.logo6}
                            className={classNames(projectcss.all, sty.logo6)}
                          >
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__ttifX)}
                              displayHeight={"31.118px"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"100%"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"81.331px"}
                              loader={"plasmic"}
                              loading={"lazy"}
                              src={{
                                src: "https://site-assets.plasmic.app/6d004147be9bf2df1c0fc9c34fd4a6ad.svg",
                                fullWidth: 300,
                                fullHeight: 119,
                                aspectRatio: 2.527778
                              }}
                            />
                          </div>
                        </div>
                      ) : null}
                      {(
                        hasVariant(globalVariants, "mobile", "mobileXSmall")
                          ? true
                          : hasVariant(globalVariants, "mobile", "mobile")
                            ? false
                            : true
                      ) ? (
                        <PlasmicImg__
                          alt={""}
                          className={classNames(sty.img__ypIGh)}
                          displayHeight={
                            hasVariant(globalVariants, "mobile", "mobileXSmall")
                              ? "100%"
                              : hasVariant(globalVariants, "mobile", "mobile")
                                ? "264px"
                                : "264px"
                          }
                          displayMaxHeight={"none"}
                          displayMaxWidth={"none"}
                          displayMinHeight={"0"}
                          displayMinWidth={"0"}
                          displayWidth={
                            hasVariant(globalVariants, "mobile", "mobile")
                              ? "100%"
                              : "100%"
                          }
                          loader={"plasmic"}
                          loading={"lazy"}
                          src={
                            hasVariant(globalVariants, "mobile", "mobile")
                              ? {
                                  src: "https://site-assets.plasmic.app/5f69d0ae80078306b32c050a00cbd070.svg",
                                  fullWidth: 348,
                                  fullHeight: 264,
                                  aspectRatio: 1.318182
                                }
                              : {
                                  src: "https://site-assets.plasmic.app/7b1b21c1f40f5123d7c92c6a77d00638.svg",
                                  fullWidth: 348,
                                  fullHeight: 264,
                                  aspectRatio: 1.318182
                                }
                          }
                        />
                      ) : null}
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"row4"}
                    data-plasmic-override={overrides.row4}
                    className={classNames(projectcss.all, sty.row4)}
                  >
                    <div
                      data-plasmic-name={"leftColumn2"}
                      data-plasmic-override={overrides.leftColumn2}
                      className={classNames(projectcss.all, sty.leftColumn2)}
                    >
                      <Accordion
                        className={classNames(
                          "__wab_instance",
                          sty.accordion__um76U
                        )}
                      >
                        {(_par =>
                          !_par ? [] : Array.isArray(_par) ? _par : [_par])(
                          (() => {
                            try {
                              return $ctx.products;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()
                        ).map((__plasmic_item_0, __plasmic_idx_0) => {
                          const currentItem = __plasmic_item_0;
                          const currentIndex = __plasmic_idx_0;
                          return (
                            <AccordionSection
                              active={(() => {
                                try {
                                  return currentIndex === $state.accordion;
                                } catch (e) {
                                  if (
                                    e instanceof TypeError ||
                                    e?.plasmicType ===
                                      "PlasmicUndefinedDataError"
                                  ) {
                                    return [];
                                  }
                                  throw e;
                                }
                              })()}
                              body={
                                <div
                                  data-plasmic-name={"bodyWrapper2"}
                                  data-plasmic-override={overrides.bodyWrapper2}
                                  className={classNames(
                                    projectcss.all,
                                    sty.bodyWrapper2
                                  )}
                                >
                                  <AccordionSectionSplashImage
                                    className={classNames(
                                      "__wab_instance",
                                      sty.accordionSectionSplashImage__zu3Hs
                                    )}
                                    product={(() => {
                                      try {
                                        return currentItem.product;
                                      } catch (e) {
                                        if (
                                          e instanceof TypeError ||
                                          e?.plasmicType ===
                                            "PlasmicUndefinedDataError"
                                        ) {
                                          return "myEvaluations";
                                        }
                                        throw e;
                                      }
                                    })()}
                                  />

                                  <div
                                    data-plasmic-name={"text2"}
                                    data-plasmic-override={overrides.text2}
                                    className={classNames(
                                      projectcss.all,
                                      sty.text2
                                    )}
                                  >
                                    <h4
                                      data-plasmic-name={"title2"}
                                      data-plasmic-override={overrides.title2}
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.h4,
                                        projectcss.__wab_text,
                                        sty.title2
                                      )}
                                    >
                                      <React.Fragment>
                                        {(() => {
                                          try {
                                            return currentItem.title;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return "Experience the Future of Medical Education Management";
                                            }
                                            throw e;
                                          }
                                        })()}
                                      </React.Fragment>
                                    </h4>
                                    <p
                                      data-plasmic-name={"subtitle2"}
                                      data-plasmic-override={
                                        overrides.subtitle2
                                      }
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.p,
                                        projectcss.__wab_text,
                                        sty.subtitle2
                                      )}
                                    >
                                      <React.Fragment>
                                        {(() => {
                                          try {
                                            return currentItem.subtitle;
                                          } catch (e) {
                                            if (
                                              e instanceof TypeError ||
                                              e?.plasmicType ===
                                                "PlasmicUndefinedDataError"
                                            ) {
                                              return "MyEvaluations revolutionizes medical training management with streamlined scheduling, patient logs, clinical hour compliance, and custom evaluations. Its efficient workflow and secure, accessible platform save time, resources, and paper, while enabling comprehensive reports and early intervention alerts for improved training outcomes.";
                                            }
                                            throw e;
                                          }
                                        })()}
                                      </React.Fragment>
                                    </p>
                                  </div>
                                  <div
                                    data-plasmic-name={"features2"}
                                    data-plasmic-override={overrides.features2}
                                    className={classNames(
                                      projectcss.all,
                                      sty.features2
                                    )}
                                  >
                                    <h6
                                      className={classNames(
                                        projectcss.all,
                                        projectcss.h6,
                                        projectcss.__wab_text,
                                        sty.h6__ik06C
                                      )}
                                    >
                                      {"Key Features"}
                                    </h6>
                                    <div
                                      data-plasmic-name={"list2"}
                                      data-plasmic-override={overrides.list2}
                                      className={classNames(
                                        projectcss.all,
                                        sty.list2
                                      )}
                                    >
                                      <div
                                        className={classNames(
                                          projectcss.all,
                                          projectcss.__wab_text,
                                          sty.text__yUkTt
                                        )}
                                      >
                                        <React.Fragment>
                                          <React.Fragment>{""}</React.Fragment>
                                          {
                                            <ul
                                              className={classNames(
                                                projectcss.all,
                                                projectcss.ul,
                                                sty.ul__lzURt
                                              )}
                                            >
                                              {(_par =>
                                                !_par
                                                  ? []
                                                  : Array.isArray(_par)
                                                    ? _par
                                                    : [_par])(
                                                (() => {
                                                  try {
                                                    return currentItem
                                                      .bulletPoints
                                                      .bulletpointsLeft;
                                                  } catch (e) {
                                                    if (
                                                      e instanceof TypeError ||
                                                      e?.plasmicType ===
                                                        "PlasmicUndefinedDataError"
                                                    ) {
                                                      return [];
                                                    }
                                                    throw e;
                                                  }
                                                })()
                                              ).map(
                                                (
                                                  __plasmic_item_1,
                                                  __plasmic_idx_1
                                                ) => {
                                                  const currentItem =
                                                    __plasmic_item_1;
                                                  const currentIndex =
                                                    __plasmic_idx_1;
                                                  return (
                                                    <li
                                                      className={classNames(
                                                        projectcss.all,
                                                        projectcss.li,
                                                        projectcss.__wab_text,
                                                        sty.li__sdFog
                                                      )}
                                                      key={currentIndex}
                                                    >
                                                      <React.Fragment>
                                                        {currentItem}
                                                      </React.Fragment>
                                                    </li>
                                                  );
                                                }
                                              )}
                                            </ul>
                                          }
                                          <React.Fragment>{""}</React.Fragment>
                                        </React.Fragment>
                                      </div>
                                      <div
                                        className={classNames(
                                          projectcss.all,
                                          projectcss.__wab_text,
                                          sty.text___5Nfzb
                                        )}
                                      >
                                        <React.Fragment>
                                          <React.Fragment>{""}</React.Fragment>
                                          {
                                            <ul
                                              className={classNames(
                                                projectcss.all,
                                                projectcss.ul,
                                                sty.ul__rWzQr
                                              )}
                                            >
                                              {(_par =>
                                                !_par
                                                  ? []
                                                  : Array.isArray(_par)
                                                    ? _par
                                                    : [_par])(
                                                (() => {
                                                  try {
                                                    return currentItem
                                                      .bulletPoints
                                                      .bulletpointsRight;
                                                  } catch (e) {
                                                    if (
                                                      e instanceof TypeError ||
                                                      e?.plasmicType ===
                                                        "PlasmicUndefinedDataError"
                                                    ) {
                                                      return [];
                                                    }
                                                    throw e;
                                                  }
                                                })()
                                              ).map(
                                                (
                                                  __plasmic_item_1,
                                                  __plasmic_idx_1
                                                ) => {
                                                  const currentItem =
                                                    __plasmic_item_1;
                                                  const currentIndex =
                                                    __plasmic_idx_1;
                                                  return (
                                                    <li
                                                      className={classNames(
                                                        projectcss.all,
                                                        projectcss.li,
                                                        projectcss.__wab_text,
                                                        sty.li___4Vl6C
                                                      )}
                                                      key={currentIndex}
                                                    >
                                                      <React.Fragment>
                                                        {currentItem}
                                                      </React.Fragment>
                                                    </li>
                                                  );
                                                }
                                              )}
                                            </ul>
                                          }
                                          <React.Fragment>{""}</React.Fragment>
                                        </React.Fragment>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                              className={classNames(
                                "__wab_instance",
                                sty.accordionSection__kpDdj
                              )}
                              header={
                                <AccordionSectionHeader
                                  active={(() => {
                                    try {
                                      return currentIndex === $state.accordion;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })()}
                                  className={classNames(
                                    "__wab_instance",
                                    sty.accordionSectionHeader__zlygf
                                  )}
                                  onClick={async () => {
                                    const $steps = {};

                                    $steps["updateAccordion"] = true
                                      ? (() => {
                                          const actionArgs = {
                                            variable: {
                                              objRoot: $state,
                                              variablePath: ["accordion"]
                                            },
                                            operation: 0,
                                            value: currentIndex
                                          };
                                          return (({
                                            variable,
                                            value,
                                            startIndex,
                                            deleteCount
                                          }) => {
                                            if (!variable) {
                                              return;
                                            }
                                            const { objRoot, variablePath } =
                                              variable;

                                            $stateSet(
                                              objRoot,
                                              variablePath,
                                              value
                                            );
                                            return value;
                                          })?.apply(null, [actionArgs]);
                                        })()
                                      : undefined;
                                    if (
                                      $steps["updateAccordion"] != null &&
                                      typeof $steps["updateAccordion"] ===
                                        "object" &&
                                      typeof $steps["updateAccordion"].then ===
                                        "function"
                                    ) {
                                      $steps["updateAccordion"] =
                                        await $steps["updateAccordion"];
                                    }
                                  }}
                                  order={(() => {
                                    try {
                                      return currentIndex === 0
                                        ? "first"
                                        : currentIndex ===
                                            $ctx.products.length - 1
                                          ? "last"
                                          : "";
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return [];
                                      }
                                      throw e;
                                    }
                                  })()}
                                  product={(() => {
                                    try {
                                      return currentItem.product;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                  title={(() => {
                                    try {
                                      return currentItem.header;
                                    } catch (e) {
                                      if (
                                        e instanceof TypeError ||
                                        e?.plasmicType ===
                                          "PlasmicUndefinedDataError"
                                      ) {
                                        return undefined;
                                      }
                                      throw e;
                                    }
                                  })()}
                                />
                              }
                              key={currentIndex}
                            />
                          );
                        })}
                      </Accordion>
                    </div>
                  </div>
                  <div
                    data-plasmic-name={"quote"}
                    data-plasmic-override={overrides.quote}
                    className={classNames(projectcss.all, sty.quote)}
                  >
                    <HomeProductsSectionQuote
                      className={classNames(
                        "__wab_instance",
                        sty.homeProductsSectionQuote__ufWhC
                      )}
                    />

                    {false ? (
                      <div
                        data-plasmic-name={"sliderNavigation2"}
                        data-plasmic-override={overrides.sliderNavigation2}
                        className={classNames(
                          projectcss.all,
                          sty.sliderNavigation2
                        )}
                      >
                        <div
                          data-plasmic-name={"sliderNavigationBullet10"}
                          data-plasmic-override={
                            overrides.sliderNavigationBullet10
                          }
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigationBullet10
                          )}
                        />

                        <div
                          data-plasmic-name={"sliderNavigationBullet11"}
                          data-plasmic-override={
                            overrides.sliderNavigationBullet11
                          }
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigationBullet11
                          )}
                        />

                        <div
                          data-plasmic-name={"sliderNavigationBullet12"}
                          data-plasmic-override={
                            overrides.sliderNavigationBullet12
                          }
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigationBullet12
                          )}
                        />

                        <div
                          data-plasmic-name={"sliderNavigationBullet13"}
                          data-plasmic-override={
                            overrides.sliderNavigationBullet13
                          }
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigationBullet13
                          )}
                        />

                        <div
                          data-plasmic-name={"sliderNavigationBullet14"}
                          data-plasmic-override={
                            overrides.sliderNavigationBullet14
                          }
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigationBullet14
                          )}
                        />

                        <div
                          data-plasmic-name={"sliderNavigationBullet15"}
                          data-plasmic-override={
                            overrides.sliderNavigationBullet15
                          }
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigationBullet15
                          )}
                        />

                        <div
                          data-plasmic-name={"sliderNavigationBullet16"}
                          data-plasmic-override={
                            overrides.sliderNavigationBullet16
                          }
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigationBullet16
                          )}
                        />

                        <div
                          data-plasmic-name={"sliderNavigationBullet17"}
                          data-plasmic-override={
                            overrides.sliderNavigationBullet17
                          }
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigationBullet17
                          )}
                        />

                        <div
                          data-plasmic-name={"sliderNavigationBullet18"}
                          data-plasmic-override={
                            overrides.sliderNavigationBullet18
                          }
                          className={classNames(
                            projectcss.all,
                            sty.sliderNavigationBullet18
                          )}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              ) : null}
            </React.Fragment>
          )}
        </DataCtxReader__>
      </DataProvider>
    </section>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  productsSection: [
    "productsSection",
    "productsProvider",
    "desktopWrapper",
    "row",
    "row2",
    "leftColumn",
    "bodyWrapper",
    "imgWrapper",
    "text",
    "title",
    "subtitle",
    "features",
    "list",
    "rightColumn",
    "nav",
    "sliderNavigation",
    "sliderNavigationBullet",
    "sliderNavigationBullet2",
    "sliderNavigationBullet3",
    "sliderNavigationBullet4",
    "sliderNavigationBullet5",
    "sliderNavigationBullet6",
    "sliderNavigationBullet7",
    "sliderNavigationBullet8",
    "sliderNavigationBullet9",
    "mobileWrapper",
    "row3",
    "freeBox",
    "nav2",
    "img5",
    "logoIcon2",
    "logo4",
    "logo5",
    "logo6",
    "row4",
    "leftColumn2",
    "bodyWrapper2",
    "text2",
    "title2",
    "subtitle2",
    "features2",
    "list2",
    "quote",
    "sliderNavigation2",
    "sliderNavigationBullet10",
    "sliderNavigationBullet11",
    "sliderNavigationBullet12",
    "sliderNavigationBullet13",
    "sliderNavigationBullet14",
    "sliderNavigationBullet15",
    "sliderNavigationBullet16",
    "sliderNavigationBullet17",
    "sliderNavigationBullet18"
  ],
  productsProvider: [
    "productsProvider",
    "desktopWrapper",
    "row",
    "row2",
    "leftColumn",
    "bodyWrapper",
    "imgWrapper",
    "text",
    "title",
    "subtitle",
    "features",
    "list",
    "rightColumn",
    "nav",
    "sliderNavigation",
    "sliderNavigationBullet",
    "sliderNavigationBullet2",
    "sliderNavigationBullet3",
    "sliderNavigationBullet4",
    "sliderNavigationBullet5",
    "sliderNavigationBullet6",
    "sliderNavigationBullet7",
    "sliderNavigationBullet8",
    "sliderNavigationBullet9",
    "mobileWrapper",
    "row3",
    "freeBox",
    "nav2",
    "img5",
    "logoIcon2",
    "logo4",
    "logo5",
    "logo6",
    "row4",
    "leftColumn2",
    "bodyWrapper2",
    "text2",
    "title2",
    "subtitle2",
    "features2",
    "list2",
    "quote",
    "sliderNavigation2",
    "sliderNavigationBullet10",
    "sliderNavigationBullet11",
    "sliderNavigationBullet12",
    "sliderNavigationBullet13",
    "sliderNavigationBullet14",
    "sliderNavigationBullet15",
    "sliderNavigationBullet16",
    "sliderNavigationBullet17",
    "sliderNavigationBullet18"
  ],
  desktopWrapper: [
    "desktopWrapper",
    "row",
    "row2",
    "leftColumn",
    "bodyWrapper",
    "imgWrapper",
    "text",
    "title",
    "subtitle",
    "features",
    "list",
    "rightColumn",
    "nav",
    "sliderNavigation",
    "sliderNavigationBullet",
    "sliderNavigationBullet2",
    "sliderNavigationBullet3",
    "sliderNavigationBullet4",
    "sliderNavigationBullet5",
    "sliderNavigationBullet6",
    "sliderNavigationBullet7",
    "sliderNavigationBullet8",
    "sliderNavigationBullet9"
  ],
  row: ["row"],
  row2: [
    "row2",
    "leftColumn",
    "bodyWrapper",
    "imgWrapper",
    "text",
    "title",
    "subtitle",
    "features",
    "list",
    "rightColumn",
    "nav",
    "sliderNavigation",
    "sliderNavigationBullet",
    "sliderNavigationBullet2",
    "sliderNavigationBullet3",
    "sliderNavigationBullet4",
    "sliderNavigationBullet5",
    "sliderNavigationBullet6",
    "sliderNavigationBullet7",
    "sliderNavigationBullet8",
    "sliderNavigationBullet9"
  ],
  leftColumn: [
    "leftColumn",
    "bodyWrapper",
    "imgWrapper",
    "text",
    "title",
    "subtitle",
    "features",
    "list"
  ],
  bodyWrapper: [
    "bodyWrapper",
    "imgWrapper",
    "text",
    "title",
    "subtitle",
    "features",
    "list"
  ],
  imgWrapper: ["imgWrapper"],
  text: ["text", "title", "subtitle"],
  title: ["title"],
  subtitle: ["subtitle"],
  features: ["features", "list"],
  list: ["list"],
  rightColumn: [
    "rightColumn",
    "nav",
    "sliderNavigation",
    "sliderNavigationBullet",
    "sliderNavigationBullet2",
    "sliderNavigationBullet3",
    "sliderNavigationBullet4",
    "sliderNavigationBullet5",
    "sliderNavigationBullet6",
    "sliderNavigationBullet7",
    "sliderNavigationBullet8",
    "sliderNavigationBullet9"
  ],
  nav: ["nav"],
  sliderNavigation: [
    "sliderNavigation",
    "sliderNavigationBullet",
    "sliderNavigationBullet2",
    "sliderNavigationBullet3",
    "sliderNavigationBullet4",
    "sliderNavigationBullet5",
    "sliderNavigationBullet6",
    "sliderNavigationBullet7",
    "sliderNavigationBullet8",
    "sliderNavigationBullet9"
  ],
  sliderNavigationBullet: ["sliderNavigationBullet"],
  sliderNavigationBullet2: ["sliderNavigationBullet2"],
  sliderNavigationBullet3: ["sliderNavigationBullet3"],
  sliderNavigationBullet4: ["sliderNavigationBullet4"],
  sliderNavigationBullet5: ["sliderNavigationBullet5"],
  sliderNavigationBullet6: ["sliderNavigationBullet6"],
  sliderNavigationBullet7: ["sliderNavigationBullet7"],
  sliderNavigationBullet8: ["sliderNavigationBullet8"],
  sliderNavigationBullet9: ["sliderNavigationBullet9"],
  mobileWrapper: [
    "mobileWrapper",
    "row3",
    "freeBox",
    "nav2",
    "img5",
    "logoIcon2",
    "logo4",
    "logo5",
    "logo6",
    "row4",
    "leftColumn2",
    "bodyWrapper2",
    "text2",
    "title2",
    "subtitle2",
    "features2",
    "list2",
    "quote",
    "sliderNavigation2",
    "sliderNavigationBullet10",
    "sliderNavigationBullet11",
    "sliderNavigationBullet12",
    "sliderNavigationBullet13",
    "sliderNavigationBullet14",
    "sliderNavigationBullet15",
    "sliderNavigationBullet16",
    "sliderNavigationBullet17",
    "sliderNavigationBullet18"
  ],
  row3: ["row3"],
  freeBox: ["freeBox", "nav2", "img5", "logoIcon2", "logo4", "logo5", "logo6"],
  nav2: ["nav2", "img5", "logoIcon2", "logo4", "logo5", "logo6"],
  img5: ["img5", "logoIcon2", "logo4", "logo5", "logo6"],
  logoIcon2: ["logoIcon2"],
  logo4: ["logo4"],
  logo5: ["logo5"],
  logo6: ["logo6"],
  row4: [
    "row4",
    "leftColumn2",
    "bodyWrapper2",
    "text2",
    "title2",
    "subtitle2",
    "features2",
    "list2"
  ],
  leftColumn2: [
    "leftColumn2",
    "bodyWrapper2",
    "text2",
    "title2",
    "subtitle2",
    "features2",
    "list2"
  ],
  bodyWrapper2: [
    "bodyWrapper2",
    "text2",
    "title2",
    "subtitle2",
    "features2",
    "list2"
  ],
  text2: ["text2", "title2", "subtitle2"],
  title2: ["title2"],
  subtitle2: ["subtitle2"],
  features2: ["features2", "list2"],
  list2: ["list2"],
  quote: [
    "quote",
    "sliderNavigation2",
    "sliderNavigationBullet10",
    "sliderNavigationBullet11",
    "sliderNavigationBullet12",
    "sliderNavigationBullet13",
    "sliderNavigationBullet14",
    "sliderNavigationBullet15",
    "sliderNavigationBullet16",
    "sliderNavigationBullet17",
    "sliderNavigationBullet18"
  ],
  sliderNavigation2: [
    "sliderNavigation2",
    "sliderNavigationBullet10",
    "sliderNavigationBullet11",
    "sliderNavigationBullet12",
    "sliderNavigationBullet13",
    "sliderNavigationBullet14",
    "sliderNavigationBullet15",
    "sliderNavigationBullet16",
    "sliderNavigationBullet17",
    "sliderNavigationBullet18"
  ],
  sliderNavigationBullet10: ["sliderNavigationBullet10"],
  sliderNavigationBullet11: ["sliderNavigationBullet11"],
  sliderNavigationBullet12: ["sliderNavigationBullet12"],
  sliderNavigationBullet13: ["sliderNavigationBullet13"],
  sliderNavigationBullet14: ["sliderNavigationBullet14"],
  sliderNavigationBullet15: ["sliderNavigationBullet15"],
  sliderNavigationBullet16: ["sliderNavigationBullet16"],
  sliderNavigationBullet17: ["sliderNavigationBullet17"],
  sliderNavigationBullet18: ["sliderNavigationBullet18"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  productsSection: "section";
  productsProvider: typeof DataProvider;
  desktopWrapper: "div";
  row: "div";
  row2: "div";
  leftColumn: "div";
  bodyWrapper: "div";
  imgWrapper: "div";
  text: "div";
  title: "h4";
  subtitle: "p";
  features: "div";
  list: "div";
  rightColumn: "div";
  nav: "div";
  sliderNavigation: "div";
  sliderNavigationBullet: "div";
  sliderNavigationBullet2: "div";
  sliderNavigationBullet3: "div";
  sliderNavigationBullet4: "div";
  sliderNavigationBullet5: "div";
  sliderNavigationBullet6: "div";
  sliderNavigationBullet7: "div";
  sliderNavigationBullet8: "div";
  sliderNavigationBullet9: "div";
  mobileWrapper: "div";
  row3: "div";
  freeBox: "div";
  nav2: "div";
  img5: "div";
  logoIcon2: "div";
  logo4: "div";
  logo5: "div";
  logo6: "div";
  row4: "div";
  leftColumn2: "div";
  bodyWrapper2: "div";
  text2: "div";
  title2: "h4";
  subtitle2: "p";
  features2: "div";
  list2: "div";
  quote: "div";
  sliderNavigation2: "div";
  sliderNavigationBullet10: "div";
  sliderNavigationBullet11: "div";
  sliderNavigationBullet12: "div";
  sliderNavigationBullet13: "div";
  sliderNavigationBullet14: "div";
  sliderNavigationBullet15: "div";
  sliderNavigationBullet16: "div";
  sliderNavigationBullet17: "div";
  sliderNavigationBullet18: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicHomeProductsSection__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicHomeProductsSection__VariantsArgs;
    args?: PlasmicHomeProductsSection__ArgsType;
    overrides?: NodeOverridesType<T>;
  } &
    // Specify variants directly as props
    Omit<PlasmicHomeProductsSection__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicHomeProductsSection__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicHomeProductsSection__ArgProps,
          internalVariantPropNames: PlasmicHomeProductsSection__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicHomeProductsSection__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "productsSection") {
    func.displayName = "PlasmicHomeProductsSection";
  } else {
    func.displayName = `PlasmicHomeProductsSection.${nodeName}`;
  }
  return func;
}

export const PlasmicHomeProductsSection = Object.assign(
  // Top-level PlasmicHomeProductsSection renders the root element
  makeNodeComponent("productsSection"),
  {
    // Helper components rendering sub-elements
    productsProvider: makeNodeComponent("productsProvider"),
    desktopWrapper: makeNodeComponent("desktopWrapper"),
    row: makeNodeComponent("row"),
    row2: makeNodeComponent("row2"),
    leftColumn: makeNodeComponent("leftColumn"),
    bodyWrapper: makeNodeComponent("bodyWrapper"),
    imgWrapper: makeNodeComponent("imgWrapper"),
    text: makeNodeComponent("text"),
    title: makeNodeComponent("title"),
    subtitle: makeNodeComponent("subtitle"),
    features: makeNodeComponent("features"),
    list: makeNodeComponent("list"),
    rightColumn: makeNodeComponent("rightColumn"),
    nav: makeNodeComponent("nav"),
    sliderNavigation: makeNodeComponent("sliderNavigation"),
    sliderNavigationBullet: makeNodeComponent("sliderNavigationBullet"),
    sliderNavigationBullet2: makeNodeComponent("sliderNavigationBullet2"),
    sliderNavigationBullet3: makeNodeComponent("sliderNavigationBullet3"),
    sliderNavigationBullet4: makeNodeComponent("sliderNavigationBullet4"),
    sliderNavigationBullet5: makeNodeComponent("sliderNavigationBullet5"),
    sliderNavigationBullet6: makeNodeComponent("sliderNavigationBullet6"),
    sliderNavigationBullet7: makeNodeComponent("sliderNavigationBullet7"),
    sliderNavigationBullet8: makeNodeComponent("sliderNavigationBullet8"),
    sliderNavigationBullet9: makeNodeComponent("sliderNavigationBullet9"),
    mobileWrapper: makeNodeComponent("mobileWrapper"),
    row3: makeNodeComponent("row3"),
    freeBox: makeNodeComponent("freeBox"),
    nav2: makeNodeComponent("nav2"),
    img5: makeNodeComponent("img5"),
    logoIcon2: makeNodeComponent("logoIcon2"),
    logo4: makeNodeComponent("logo4"),
    logo5: makeNodeComponent("logo5"),
    logo6: makeNodeComponent("logo6"),
    row4: makeNodeComponent("row4"),
    leftColumn2: makeNodeComponent("leftColumn2"),
    bodyWrapper2: makeNodeComponent("bodyWrapper2"),
    text2: makeNodeComponent("text2"),
    title2: makeNodeComponent("title2"),
    subtitle2: makeNodeComponent("subtitle2"),
    features2: makeNodeComponent("features2"),
    list2: makeNodeComponent("list2"),
    quote: makeNodeComponent("quote"),
    sliderNavigation2: makeNodeComponent("sliderNavigation2"),
    sliderNavigationBullet10: makeNodeComponent("sliderNavigationBullet10"),
    sliderNavigationBullet11: makeNodeComponent("sliderNavigationBullet11"),
    sliderNavigationBullet12: makeNodeComponent("sliderNavigationBullet12"),
    sliderNavigationBullet13: makeNodeComponent("sliderNavigationBullet13"),
    sliderNavigationBullet14: makeNodeComponent("sliderNavigationBullet14"),
    sliderNavigationBullet15: makeNodeComponent("sliderNavigationBullet15"),
    sliderNavigationBullet16: makeNodeComponent("sliderNavigationBullet16"),
    sliderNavigationBullet17: makeNodeComponent("sliderNavigationBullet17"),
    sliderNavigationBullet18: makeNodeComponent("sliderNavigationBullet18"),

    // Metadata about props expected for PlasmicHomeProductsSection
    internalVariantProps: PlasmicHomeProductsSection__VariantProps,
    internalArgProps: PlasmicHomeProductsSection__ArgProps
  }
);

export default PlasmicHomeProductsSection;
/* prettier-ignore-end */
